import React from 'react';
import { Tag } from 'antd';

export const COMPLETED_OPTIONS = [
    { value: 0, label: '未完成' },
    { value: 1, label: '已完成' },
];

export const PAGE_SIZE_OPTIONS = ['20', '50', '100', '200', '500'];

export const DEFAULT_PAGINATION = { current: 1, pageSize: 20 };

/** ID 输入解析：空 → undefined；非纯数字 → null（调用方提示） */
export const parseIdInput = (value?: string): number | null | undefined => {
    const trimmed = value?.trim();
    if (!trimmed) return undefined;
    return /^\d+$/.test(trimmed) ? Number(trimmed) : null;
};

export const renderFlag = (value: number, redWhenYes = false): React.ReactNode =>
    value === 1 ? <Tag color={redWhenYes ? 'red' : 'green'}>是</Tag> : <Tag>否</Tag>;

/** is_order_cleaned 三态：0-未归档 1-已归档 2-归档已删除（终态，在线表与归档表均无明细） */
export const ARCHIVE_STATE = { NONE: 0, ARCHIVED: 1, DELETED: 2 } as const;

export const ARCHIVE_STATE_OPTIONS = [
    { value: ARCHIVE_STATE.NONE, label: '未归档' },
    { value: ARCHIVE_STATE.ARCHIVED, label: '已归档' },
    { value: ARCHIVE_STATE.DELETED, label: '归档已删除' },
];

export const renderArchiveState = (value: number | null): React.ReactNode => {
    switch (value ?? ARCHIVE_STATE.NONE) {
        case ARCHIVE_STATE.ARCHIVED:
            return <Tag color="green">已归档</Tag>;
        case ARCHIVE_STATE.DELETED:
            return <Tag color="red">归档已删除</Tag>;
        default:
            return <Tag>未归档</Tag>;
    }
};

export const renderDateTime = (value: string | null): string => (value ? value.replace('T', ' ') : '-');

export const MAX_RETRY_COUNT = 5;

export const RETRY_COUNT_OPTIONS = Array.from({ length: MAX_RETRY_COUNT + 1 }, (_, i) => ({ value: i, label: String(i) }));

export const renderEventStatus = (value: number | null): React.ReactNode => {
    if (value === null || value === undefined) return <Tag color="purple">未初始化</Tag>;
    if (value === 0) return <Tag color="default">无需执行</Tag>;
    if (value === 1) return <Tag color="orange">待执行</Tag>;
    if (value === 2) return <Tag color="green">已执行</Tag>;
    return <Tag>{value}</Tag>;
};

export const renderRetryCount = (value: number): React.ReactNode =>
    value >= MAX_RETRY_COUNT ? <span style={{ color: '#ff4d4f' }}>{value}（已达上限）</span> : value;
